<div *withPermissions="let allow of ['CanManageGoogleAccess']" class="card">
  <div class="card-header">
    Reporting Dashboard Access
  </div>
  <div [loadingOverlay]="isLoading" class="card-body">
    <app-table [items]="users">
      <ng-template #tableHeader>
        <tr>
          <th style="width: 40px"></th>
          <th sort field="FullName">Name</th>
          <th sort field="Username">Email</th>
          <th>Actions</th>
        </tr>
      </ng-template>
      <ng-template #tableBody let-customerUser>
        <tr>
          <td>
            <ng-container *ngIf="!customerUser.CanContact">
              <a (click)="editUser(customerUser)" title="Edit User" class="cursor-pointer">
                <i class="fas fa-pen-to-square fa-lg text-primary"></i>
              </a>
            </ng-container>
          </td>
          <td>{{ customerUser.FullName }}</td>
          <td>{{ customerUser.Username }}</td>
          <td>
            <a (click)="impersonateUser(customerUser)" title="Login" class="cursor-pointer">
              <i class="fas fa-sign-in-alt fa-2x right"></i>
            </a>
            <a (click)="sendPasswordResetEmail(customerUser)"
              title="Send Password Reset Email" class="cursor-pointer">
              <i class="fa fa-paper-plane fa-2x ms-2"></i>
            </a>
            <a [attr.href]="ssoUrls[customerUser.CustomerUserId]"
              title="Copy SSO Link" onclick="return false" class="cursor-pointer">
              <i class="fa fa-link fa-2x ms-2"></i>
            </a>
            <ng-container *ngIf="canViewOnboardingLink">
              <a [attr.href]="ssoUrls[customerUser.CustomerUserId] + '&flow=onboarding'"
                title="Copy SSO Onboarding Link" onclick="return false" class="cursor-pointer">
                <i class="fa fa-rocket fa-2x ms-2"></i>
              </a>
            </ng-container>
            <ng-container *ngIf="!customerUser.CanContact">
              <a (click)="deleteUser(customerUser)" title="Delete User" class="cursor-pointer">
                <i class="fas fa-trash-alt fa-2x text-danger float-end"></i>
              </a>
            </ng-container>
          </td>
        </tr>
      </ng-template>
    </app-table>
    <div>
      <button (click)="addUser()" class="btn btn-success float-end">
        <i class="fa fa-plus"></i>
        Add New User
      </button>
    </div>
  </div>
</div>